<template>
  <div>
    <DeleteModal modal-id="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      id="modal-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode ? $t('hospital.Add-Service') : $t('hospital.Edit-Service')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="6" cols="12">
            <b-form-group :label="$t('common.title')" label-for="name">
              <b-form-input
                v-model="EditForm.title"
                :placeholder="$t('common.title')"
              />
              <p class="text-danger mt-1">
                {{ errorForm.title }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group :label="$t('common.price')" label-for="price">
              <b-form-input
                v-model.number="EditForm.price"
                type="number"
                step="0.01"
                min="0"
                :placeholder="$t('common.price')"
              />
              <p class="text-danger mt-1">
                {{ errorForm.price }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <AutoComplete
              v-model="EditForm.type_id"
              :label="$t('hospital.ServiceTypes') || 'Service Type'"
              :placeholder="$t('hospital.ServiceTypes') || 'Service Type'"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="serviceTypes"
              text-title="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.type_id }}
            </p>
          </b-col>
          <b-col md="6" cols="12">
            <AutoComplete
              v-model="EditForm.default_doctor_id"
              :label="$t('common.doctors') || 'Default Doctor'"
              :placeholder="$t('common.doctors') || 'Default Doctor'"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="doctor"
              text-title="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.default_doctor_id }}
            </p>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.doctor-price') || 'Doctor Price'"
              label-for="default_price"
            >
              <b-form-input
                id="default_price"
                v-model.number="EditForm.default_price"
                type="number"
                step="0.01"
                min="0"
                :placeholder="$t('reception.doctor-price') || 'Doctor Price'"
              />
              <p class="text-danger mt-1">
                {{ errorForm.default_price }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          ref="button"
          variant="primary"
          class="m-0"
          :disabled="loading"
          block
          @click="submitItem"
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner v-else small />
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('hospital.services')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("hospital.Filter-Services") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.title')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="floorName"
                :placeholder="$t('common.title')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getServicesList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" />
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("hospital.services") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-service')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.add") }}
          </b-button>
        </div>

        <b-table
          v-if="!loading"
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
        >
          <!-- Column: Service Type -->
          <template #cell(service_type)="data">
            <span v-if="data.item.type">
              {{ data.item.type.name }}
            </span>
            <span v-else class="text-muted">-</span>
          </template>

          <!-- Column: Default Doctor -->
          <template #cell(default_doctor)="data">
            <span v-if="data.item.default_doctor">
              {{ data.item.default_doctor.name }}
            </span>
            <span v-else class="text-muted">-</span>
          </template>

          <!-- Column: Default Price -->
          <template #cell(default_price)="data">
            <span
              v-if="
                data.item.default_price !== null &&
                data.item.default_price !== undefined
              "
            >
              {{ data.item.default_price }}
            </span>
            <span v-else class="text-muted">-</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                delete-perm="delete-service"
                edit-perm="update-service"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Services</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getServicesList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    DeleteModal,
    BCard,
    ActionsButtons,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    AutoComplete,
  },
  mixins: [permissionChecker],
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        title: "",
        price: "",
        type_id: "",
        default_doctor_id: "",
        default_price: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        title: "",
        price: "",
        type_id: "",
        default_doctor_id: "",
        default_price: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "title", sortable: true, label: this.$t("common.title") },
        { key: "price", sortable: true, label: this.$t("common.price") },
        {
          key: "service_type",
          sortable: false,
          label: this.$t("hospital.ServiceTypes") || "Service Type",
        },
        {
          key: "default_doctor",
          sortable: false,
          label: this.$t("common.doctors") || "Default Doctor",
        },
        {
          key: "default_price",
          sortable: true,
          label: this.$t("reception.doctor-price") || "Doctor Price",
        },
        { key: "actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getServicesList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          title: "",
          price: "",
          type_id: "",
          default_doctor_id: "",
          default_price: "",
          _method: "POST",
        };
        this.errorForm = {
          title: "",
          price: "",
          type_id: "",
          default_doctor_id: "",
          default_price: "",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.title = item.title || "";
        this.EditForm.price = item.price || "";
        // Handle type_id - could be ID or object with relationship
        this.EditForm.type_id = item.type ? item.type : item.type_id || "";
        // Handle default_doctor_id - could be ID or object with relationship
        this.EditForm.default_doctor_id = item.default_doctor
          ? item.default_doctor
          : item.default_doctor_id || "";
        this.EditForm.default_price = item.default_price || "";
        this.EditForm._method = "PUT";
        this.errorForm = {
          title: "",
          price: "",
          type_id: "",
          default_doctor_id: "",
          default_price: "",
        };
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getServicesList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/service?page=${this.page}&take=${this.take}&sort=-id&filter[type]=regular&include=type,defaultDoctor`;

      if (this.floorName) {
        url += `&filter[title]=${this.floorName}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/service/${this.deleteForm.id}`)
        .then((response) => {
          this.getServicesList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: `deleted ${this.deleteForm.first_name} successfully`,
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: `Error deleting ${this.deleteForm.first_name}`,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.title = "";
      this.errorForm.price = "";
      this.errorForm.type_id = "";
      this.errorForm.default_doctor_id = "";
      this.errorForm.default_price = "";

      // Ensure type_id and default_doctor_id are IDs, not objects
      if (this.EditForm.type_id && typeof this.EditForm.type_id === "object") {
        this.EditForm.type_id = this.EditForm.type_id.id;
      }
      if (
        this.EditForm.default_doctor_id &&
        typeof this.EditForm.default_doctor_id === "object"
      ) {
        this.EditForm.default_doctor_id = this.EditForm.default_doctor_id.id;
      }

      // Clear empty fields
      for (const item in this.EditForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] === "" || this.EditForm[item] === null) {
          if (item !== "_method" && item !== "id") {
            delete this.EditForm[item];
          }
        }
      }

      // Validate required fields
      if (!this.EditForm.title) {
        count++;
        this.errorForm.title = "The title field is required.";
      }
      if (!this.EditForm.price) {
        count++;
        this.errorForm.price = "The price field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = "/service"),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getServicesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (const item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/service/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getServicesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (const item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
